// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bgl_a","AdSlotBranding__desktop":"bgl_b","AdSlotBranding__mobile":"bgl_c"};